import React, { useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
    FieldWrappers,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading,
    CalendarIcon,
    RupeeIcon
} from "../Styles/InputStyle2";
import { FaUserPlus } from "react-icons/fa";
import tw from "tailwind-styled-components";
import * as Yup from "yup";

const PurchaseDetails = ({ onClose, stepOneData, setSelectedForm, setFormData}) => {
    const initialValues = {
        depreciation: "",
        purchasePrice: "",
        purchaseDate: "",
        vendorName: "",
    };
    const validationSchema = Yup.object({
        purchaseDate: Yup.date().required("Select Purchase Date "),
        purchasePrice: Yup.number().required("Enter Purchase Price"),
    });

    const handleSubmit = (values) => {

        const payload = {
            purchaseDate: values.purchaseDate,
            purchasePrice: values.purchasePrice,
            depreciation: values.depreciation,
            vendorName: values.vendorName,
        }
        setFormData((prevFormData) => ({
            ...prevFormData,
            purchaseDetails: values,
        }));
        setSelectedForm("3");
    };
    
    const handleBack = () => {
        setSelectedForm("1");
    }
   

    return (
        <Formik initialValues={stepOneData || initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ values, setFieldValue, errors, touched }) => (
                <Form>
                    <ModalSubHeading>Step 2</ModalSubHeading>
                    <ModalHeading>Financial/Purchase Details</ModalHeading>
                    <ScrollableContent>
                        <Wrapper>
                            <InputGroup>
                                <Label htmlFor="purchaseDate">Purchased Date *</Label>
                                <FieldWrappers>
                                    <CalendarIcon />
                                    <Field
                                        type="date"
                                        name="purchaseDate"
                                        id="purchaseDate"
                                        autoComplete="off"
                                        className="pl-6"

                                        max={new Date().toISOString().split("T")[0]}
                                    />
                                </FieldWrappers>
                                {errors.purchaseDate && touched.purchaseDate && (
                                    <ErrorText>{errors.purchaseDate}</ErrorText>
                                )}
                            </InputGroup>

                            <InputGroup>
                                <Label htmlFor="purchasePrice">Purchased Price *</Label>
                                <FieldWrappers>
                                    <RupeeIcon />
                                    <Field
                                        type="text"
                                        name="purchasePrice"
                                        id="purchasePrice"
                                        className="w-full truncate pl-6"
                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </FieldWrappers>
                                {errors.purchasePrice && touched.purchasePrice && (
                                    <ErrorText>{errors.purchasePrice}</ErrorText>
                                )}
                            </InputGroup>

                            <InputGroup>
                                <Label htmlFor="depreciation">Depreciation Rate (%) </Label>
                                <FieldWrappers>
                                    <Field
                                        type="text"
                                        name="depreciation"
                                        id="depreciation"
                                        autoComplete="off"
                                        maxLength={18}

                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </FieldWrappers>
                            </InputGroup>
                            <InputGroup>
                                <Label htmlFor="vendorName">Vendor Name *</Label>
                                <FieldWrappers>
                                    <Field
                                        type="text"
                                        name="vendorName"
                                        id="vendorName"
                                        autoComplete="off"

                                    />
                                </FieldWrappers>
                            </InputGroup>
                            <div className="flex items-end justify-end -mt-2">
                                <Vendor type="button" onClick={() => {
                                    // setIsShowAddExpenses(false);
                                    // setIsAddVendor(true);

                                }}><FaUserPlus className="mr-1 mt-0.5"
                                    />Add Vendor</Vendor>
                            </div>

                        </Wrapper>
                    </ScrollableContent>
                    <ActionSection>
                        <SideCancelBtn type="button" onClick={handleBack}>
                            Back
                        </SideCancelBtn>
                        <SubmitBtn type="submit">
                            Next
                        </SubmitBtn>
                    </ActionSection>
                </Form>
            )}
        </Formik>
    );
};
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`
const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const InputGroup = tw.div`w-full flex flex-col mt-2 md:mt-0`;
const Label = tw.label`text-sm text-gray-500 font-normal mb-1.5`;

export default PurchaseDetails;